// extracted by mini-css-extract-plugin
export default {"wrap":"style-wrap-Uz4sK","title":"style-title-32Yi_","compactTitle":"style-compactTitle-1FPpR","compact":"style-compact-1pubO style-wrap-Uz4sK"};